import React, { useState } from 'react';
import '../styles/Login.css';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

const TwoFactorAuth = () => {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [resending, setResending] = useState(false);
    const navigate = useNavigate();
    const { fetchSettings } = useSettings();
    const location = useLocation();
    const email = location.state?.email || '';
    const method = location.state?.method || 'email'; // 'email' or 'google'

    const handleVerify = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post(`${process.env.NODE_ENV === "development" ? "http://localhost:8000" : "https://lms.appy.pk"}/api/verify-2fa`, {
                email,
                code,
                method
            });

            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('user', JSON.stringify(response.data.user));

            // Sync settings
            await fetchSettings();

            if (response.data.user.role === 'super_admin') {
                navigate('/super-admin');
            } else {
                navigate('/');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Invalid verification code');
        } finally {
            setLoading(false);
        }
    };

    const handleResend = async () => {
        setResending(true);
        setError('');

        try {
            await axios.post(`${process.env.NODE_ENV === "development" ? "http://localhost:8000" : "https://lms.appy.pk"}/api/resend-2fa`, { email, method });
            alert('Verification code has been resent!');
        } catch (err) {
            setError('Failed to resend code');
        } finally {
            setResending(false);
        }
    };

    return (
        <div id="auth-page">
            {/* Floating Shapes */}
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>

            <div className="auth-card">
                <div className="icon-container">
                    <img src="/logo.svg" alt="LMS Logo" className="logo-img" />
                </div>

                <div className="auth-header text-center mb-4">
                    <h3>Two-Factor Authentication</h3>
                    <p className="text-muted">
                        {method === 'email'
                            ? `Enter the 6-digit code sent to ${email}`
                            : 'Enter the code from your Google Authenticator app'}
                    </p>
                </div>

                {error && <div className="alert alert-danger py-2 small">{error}</div>}

                <form onSubmit={handleVerify}>
                    <div className="mb-4 text-start">
                        <label className="form-label fw-bold text-muted small">Verification Code</label>
                        <div className="input-group">
                            <span className="input-group-text"><i className="bi bi-shield-lock"></i></span>
                            <input
                                type="text"
                                className="form-control text-center"
                                placeholder="000000"
                                value={code}
                                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                required
                                maxLength="6"
                                style={{ letterSpacing: '8px', fontSize: '1.2rem', fontWeight: 'bold' }}
                            />
                        </div>
                    </div>

                    <button type="submit" className="btn btn-auth" disabled={loading || code.length !== 6}>
                        {loading ? (
                            <span><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Verifying...</span>
                        ) : (
                            'Verify Code'
                        )}
                    </button>
                </form>

                {method === 'email' && (
                    <div className="mt-4 text-center">
                        <small className="text-muted">
                            Didn't receive the code?{' '}
                            <button
                                onClick={handleResend}
                                className="btn btn-link btn-sm text-primary fw-bold p-0"
                                disabled={resending}
                            >
                                {resending ? 'Sending...' : 'Resend Code'}
                            </button>
                        </small>
                    </div>
                )}

                <div className="mt-3 text-center">
                    <small className="text-muted">
                        <a href="/login" className="text-primary fw-bold hover-underline">Back to Login</a>
                    </small>
                </div>
            </div>
        </div>
    );
};

export default TwoFactorAuth;
